<template>
    <div
            class="labels"
            :data-hideOnBalloon="hideOnBalloon"
    >
        <template
                v-for="(item,index) in badges"
        >
            <b-badge
                    :key="index"
                    v-if="item.value"
                    pill
                    :variant="item.variant ? item.variant : 'gray-900'"
                    class="m-1 text-uppercase"
                    :class="{'branding-primary-bg-color': item.variant === 'success'}"
            >
                {{ item.text }}
            </b-badge>
        </template>
    </div>
</template>

<script>
    import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
    import './PropertyListingCardLabels.scss';
    import './PropertyListingCardLabels.sm.scss';
    import Moment from "moment";
    import {mapGetters} from "vuex";
    import PropertyAppResource from "@milestoneslabs/milestones-core-js/src/AppResources/PropertyAppResource";

    const NEW = {
        text: 'NEW',
        variant: 'blue',
        value: false,
    };
    const PENDING = {
        text: 'PENDING',
        variant: 'red',
        value: false,
    };
    const OPEN = {
        text: 'OPEN',
        variant: 'green',
        value: false,
    };
    const OPEN_HOUSE = {
        text: 'OPEN HOUSE',
        value: false,
    };
    const FORECLOSURE = {
        text: 'FORECLOSURE',
        value: false,
    };
    const NEW_CONSTRUCTION = {
        text: 'NEW CONSTRUCTION',
        value: false,
    };
    const FOR_SALE_BY_OWNER = {
        text: 'FOR SALE BY OWNER',
        value: false,
    };
    const SOLD = {
        text: 'SOLD',
        variant: 'red',
        value: false,
    };
    const OFF_MARKET = {
        text: 'OFF MARKET',
        value: false,
        variant: 'red',
    };
    const MY_HOME = {
        text: 'MY HOME',
        variant: 'success',
        value: false,
    };
    export default {
        name: "PropertyListingCardLabels",
        props: {
            propertyAppResource: {
                type: AppResource,
                required: true
            },
            hideOnBalloon: {
                type: Boolean,
                required: true,
            },
        },
        data() {
            return {
                badges: []
            };
        },
        mounted() {
            if (this.propertyAppResource.isSold && !this.isMyHome) {
                let text = 'SOLD ';
                if (this.propertyAppResource.details.saleDate) {
                    const date = Moment.unix(this.propertyAppResource.details.saleDate);
                    text += date.format('ll');
                }
                let soldBadge = {
                    ...SOLD,
                    text: text,
                    value: true
                };
                this.badges.push(soldBadge);

                return;
            }

            if (this.isOffMarket && !this.isMyHome) {
                let newBadge = {
                    ...OFF_MARKET,
                    value: true
                };
                this.badges.push(newBadge);

                return;
            }

            if (this.isNew && !this.isMyHome) {
                let newBadge = {
                    ...NEW,
                    value: true
                };
                this.badges.push(newBadge);
            }

            if (this.isPending && !this.isMyHome) {
                let newBadge = {
                    ...PENDING,
                    value: true
                };
                this.badges.push(newBadge);
            }

            if (this.isMyHome) {
                let myHomeBadge = {
                    ...MY_HOME,
                    value: true
                };
                this.badges.push(myHomeBadge);
            }
            if (this.propertyAppResource.isSold && !this.isMyHome) {
                let text = 'SOLD ';
                if (this.propertyAppResource.details.saleDate) {
                    const date = Moment.unix(this.propertyAppResource.details.saleDate);
                    text += date.format('ll');
                }
                let soldBadge = {
                    ...SOLD,
                    text: text,
                    value: true
                };
                this.badges.push(soldBadge);
            }
        },
        computed: {
            ...mapGetters({
                coreProperty: 'getCoreProperty',
            }),
            isNew() {
                return this.propertyAppResource.details.daysOnMarket &&
                    this.propertyAppResource.details.daysOnMarket <= 7;
            },
            isOffMarket() {
                /* after the update on milestones engine this field comes in requests snake case*/
                return !!this.propertyAppResource.offMarketAt || !!this.propertyAppResource.off_market_at;
            },
            isMyHome() {
                if (!this.coreProperty) {
                    return false;
                }
                return this.propertyAppResource.uuid === this.coreProperty.uuid;
            },
            isPending() {
                return !!this.propertyAppResource.isPending;
            },
        }
    };
</script>
